import { Link } from 'react-router-dom';
import InfoPage from './InfoPage';
import { appInfo } from '@/lib/appInfo';

const supportEmail = appInfo.supportEmail ?? 'support@lavyntutor.com';

export default function ContactPage() {
  return (
    <InfoPage title="Contact LAVYN" intro="Contact LAVYN for account help, technical support or privacy requests.">
      <section className="public-notice" aria-labelledby="contact-email">
        <h2 id="contact-email">Email support</h2>
        <p>
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </p>
        <p>For account-specific requests, write from the email address associated with your account where possible. Do not send passwords, sign-in codes, payment card details or unnecessary sensitive schoolwork.</p>
      </section>
      <section aria-labelledby="contact-help">
        <h2 id="contact-help">If something is not working</h2>
        <p>Check your connection and use the retry option shown in the app. If a problem continues, include the error message and the steps that led to it in your email. Do not include passwords or sign-in codes.</p>
        <p>For a guide to asking questions and using study tools, visit <Link to="/about">About LAVYN</Link>. Help &amp; Support in <Link to="/profile">Profile</Link> also has answers to common usage questions.</p>
      </section>
    </InfoPage>
  );
}
